const DATA_PREFIX = 'data:';

export const createAgentStreamState = () => ({
  buffer: '',
});

const parseEvent = (rawData) => {
  const data = rawData.trim();
  if (!data || data === '[DONE]') {
    return { done: data === '[DONE]', delta: '' };
  }

  try {
    const event = JSON.parse(data);
    if (event.type === 'text-delta') {
      return { done: false, delta: event.delta || '' };
    }
    if (event.type === 'results' || event.type === 'result' || event.type === 'components' || event.type === 'component') {
      return { done: false, delta: '', results: event.results || event.result || event.components || event.component || event.data || [] };
    }
    if (event.type === 'error') {
      return { done: false, delta: '', error: event.errorText || 'The agent stream failed.' };
    }
    return { done: false, delta: '' };
  } catch (err) {
    return { done: false, delta: data };
  }
};

export const readAgentStreamChunk = (chunk, state) => {
  state.buffer += chunk;

  const lines = state.buffer.split(/\r?\n/);
  state.buffer = lines.pop() || '';

  return lines.reduce(
    (result, line) => {
      if (!line.startsWith(DATA_PREFIX)) {
        return result;
      }

      const event = parseEvent(line.slice(DATA_PREFIX.length));
      return {
        done: result.done || event.done,
        delta: `${result.delta}${event.delta || ''}`,
        results: [...result.results, ...(Array.isArray(event.results) ? event.results : event.results ? [event.results] : [])],
        error: result.error || event.error,
      };
    },
    { done: false, delta: '', results: [], error: null }
  );
};
